import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminAnalyticsSection } from "@/pages/Admin";
import ProgressBar from "@/components/ProgressBar";

export default function AdminProgressPage() {
    const [users, setUsers] = useState([]);
    const [modules, setModules] = useState([]);
    const [progressByUser, setProgressByUser] = useState({});

    useEffect(() => {
        Promise.all([api.get("/admin/users").then((r) => r.data), api.get("/admin/modules").then((r) => r.data)])
            .then(([u, m]) => {
                setUsers(u.filter((x) => x.role === "trainee" && (x.status || "active") !== "archived"));
                setModules(m);
            });
    }, []);

    useEffect(() => {
        // Lazy-load progress for visible trainees
        users.forEach((u) => {
            if (progressByUser[u.id]) return;
            api.get(`/admin/trainee-progress/${u.id}`).then((r) => {
                setProgressByUser((prev) => ({ ...prev, [u.id]: r.data }));
            }).catch(() => {});
        });
        // eslint-disable-next-line
    }, [users]);

    const completionPct = (uid) => {
        const data = progressByUser[uid];
        if (!data || modules.length === 0) return 0;
        const totalLessons = modules.reduce((s, m) => s + (m.lesson_count ?? 0), 0);
        if (!totalLessons) return 0;
        const completed = (data.progress || []).filter((p) => p.lesson_id && p.completed).length;
        return Math.round((completed / totalLessons) * 100);
    };

    return (
        <div className="space-y-10" data-testid="admin-progress-page">
            <AdminAnalyticsSection />

            <div>
                <div className="font-heading text-xl text-ink-900 mb-4">Trainee progress</div>
                <div className="bg-white border border-ink-300 divide-y divide-ink-200">
                    {users.length === 0 && <div className="px-6 py-6 text-sm text-ink-500" data-testid="trainee-progress-empty">No trainees yet.</div>}
                    {users.map((u) => (
                        <div key={u.id} className="px-6 py-4 grid md:grid-cols-[1.5fr_1fr_180px_60px] gap-4 items-center" data-testid={`trainee-progress-${u.id}`}>
                            <div>
                                <div className="text-sm text-ink-900 font-medium">{u.name}</div>
                                <div className="text-xs text-ink-500">{u.email}</div>
                            </div>
                            <div className="text-sm text-ink-700">{u.cohort || <span className="text-ink-400">—</span>}</div>
                            <ProgressBar value={completionPct(u.id)} size="sm" />
                            <div className="text-sm text-ink-500 font-mono text-right">{completionPct(u.id)}%</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
